import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { getPaletteColor, IconButton } from 'pcln-design-system'
import { ArrowUp } from 'pcln-icons'
import throttle from 'lodash/throttle'

function getResponsiveContainerStyles(props) {
  return props.displayAds
    ? // With ads
      `
      ${props.theme.flyQueries.tablet} {
        margin-right: -15px;
      }

      ${props.theme.flyQueries.tablethd} {
        bottom: 0;
        right: 182px;
      }

      ${props.theme.flyQueries.desktoplg} {
        left: 50%;
        margin-left: 268px;
      }
    `
    : // Without ads
      `
      ${props.theme.flyQueries.tablet} {
        bottom: 10px;
        right: 14px;
      }

      ${props.theme.flyQueries.desktophd} {
        left: 70%;
        margin-left: 285px;
      }
    `
}

const Container = styled.div`
  bottom: 80px;
  cursor: pointer;
  height: 80px;
  margin-right: -20px;
  opacity: 0;
  position: fixed;
  right: 10px;
  transform: translatez(0);
  transition: opacity 200ms;
  width: 80px;
  z-index: -10;

  &.show {
    z-index: 10;
    opacity: 1;
  }

  ${props => getResponsiveContainerStyles(props)}
`

const CircleButton = styled(IconButton)`
  background-color: ${getPaletteColor('primary.base')};
  z-index: 2;
  position: absolute;
  margin: 16px;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  text-align: center;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${getPaletteColor('primary.dark')};
  }
`

class BackToTop extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isVisible: false,
      throttledHandler: throttle(this.handleScroll, 500),
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.state.throttledHandler, {
      passive: true,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.state.throttledHandler)
  }

  handleScroll = () => {
    const scrollPosition =
      document.documentElement.scrollTop || window.pageYOffset || window.scrollY
    const isVisible = scrollPosition > 0

    if (isVisible) {
      if (!this.state.isVisible) {
        this.setState({
          isVisible: true,
          containerCss: classNames({
            show: true,
          }),
        })
      }
    } else if (this.state.isVisible) {
      this.setState({
        isVisible: false,
        containerCss: classNames({
          show: false,
        }),
      })
    }
  }

  scrollTop = () => {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <Container
        className={this.state.containerCss}
        displayAds={this.props.displayAds}
      >
        <CircleButton
          aria-label='Back to top of listings'
          onClick={this.scrollTop}
          icon={<ArrowUp color='background.lightest' />}
        />
      </Container>
    )
  }
}

BackToTop.defaultProps = {
  displayAds: true,
}

BackToTop.propTypes = {
  // Adjust button placement depending on whether or not ads are displayed
  displayAds: PropTypes.bool,
}

export { BackToTop }
